<template>
	<div class="v-container">
		<div class="v-page-header">主体管理</div>
		<div class="v-header">
			<el-button size="small" type="primary" @click="row=null;isShowAddEdit=true;">新增主体</el-button>
			<div></div>
		</div>
		<div v-loading="loading" class="v-content">
			<el-table :data="lists" bordered row-key="id" height="100%" size="small" border>
				<el-table-column label="ID" prop="id" width="100" />
				<el-table-column label="主体名称" prop="name" />
				<el-table-column label="主体类型">
					<template slot-scope="scope">{{ scope.row.type == 1 ?'SaaS' : '代理商' }}</template>
				</el-table-column>
				<el-table-column label="所属行政区" width="180">
					<template slot-scope="scope">{{ scope.row.province }}-{{ scope.row.city }}-{{ scope.row.area }}</template>
				</el-table-column>
				<el-table-column label="状态" prop="type" width="100" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1" class="v-color-green">启用</span> <span v-if="scope.row.status == 2" class="v-color-red">禁用</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作" width="120">
					<template slot-scope="scope">
						<el-button size="min" class="v-ml-5" icon="el-icon-edit" @click="row=scope.row;isShowAddEdit=true;"></el-button>
						<el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
							<el-button slot="reference" size="min" class="v-ml-5" icon="el-icon-delete" :loading="scope.row.deleteLoading"></el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<addEdit v-if="isShowAddEdit" :show.sync="isShowAddEdit" :row="row" @success="getList"></addEdit>
	</div>
</template>

<script>
	import addEdit from './components/add-edit'

	export default {

		components: {addEdit},

		data() {
			return {
				loading: false,
				lists: [],
				row: null,
				isShowAddEdit: false
			};
		},
		created() {
			this.getList();
		},

		methods: {
			async getList() {
				this.loading = true;
				try {
					let res = await this.api.subject.listsAll();
					this.lists = res.data;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			//删除
			async doDelete(row) {
				this.$set(row, 'deleteLoading', true);
				try {
					await this.api.subject.delete({id: row.id});
					this.$message.success('删除成功');
					this.getList();
				} catch (e) {
					console.error(e);
				}
				this.$set(row, 'deleteLoading', false);
			},
		},

	};
</script>

